import type { Vehicle } from '../lib/vehicles';

// Readdy AI generated images — specific prompts per vehicle for accurate matching
const IMG: Record<string, string> = {
  rav4_2021:     'https://public.readdy.ai/ai/img_res/721477b83a25ea9a6eb20f666667166b.jpg',
  f150_2019:     'https://readdy.ai/api/search-image?query=2019%20Ford%20F-150%20XLT%20crew%20cab%20oxford%20white%20pickup%20truck%20parked%20on%20clean%20white%20studio%20background%20front%20three%20quarter%20view%20professional%20automotive%20photography%20sharp%20detail%20neutral%20background&width=800&height=600&seq=f150_2019_v1&orientation=landscape',
  crv_2020:      'https://readdy.ai/api/search-image?query=2020%20Honda%20CR-V%20EX%20sonic%20gray%20pearl%20compact%20SUV%20crossover%20parked%20on%20clean%20white%20studio%20background%20front%20three%20quarter%20view%20professional%20automotive%20photography%20sharp%20detail%20neutral%20background&width=800&height=600&seq=crv_2020_v1&orientation=landscape',
  outback_2018:  'https://readdy.ai/api/search-image?query=2018%20Subaru%20Outback%202.5i%20wilderness%20green%20wagon%20crossover%20parked%20on%20clean%20white%20studio%20background%20front%20three%20quarter%20view%20professional%20automotive%20photography%20sharp%20detail%20neutral%20background&width=800&height=600&seq=outback_2018_v1&orientation=landscape',
  silverado_2022:'https://readdy.ai/api/search-image?query=2022%20Chevrolet%20Silverado%201500%20LT%20summit%20white%20full%20size%20crew%20cab%20pickup%20truck%20parked%20on%20clean%20white%20studio%20background%20front%20three%20quarter%20view%20professional%20automotive%20photography%20sharp%20detail%20neutral%20background&width=800&height=600&seq=silverado_2022_v1&orientation=landscape',
  camry_2020:    'https://readdy.ai/api/search-image?query=2020%20Toyota%20Camry%20SE%20midnight%20black%20sedan%20parked%20on%20clean%20white%20studio%20background%20front%20three%20quarter%20view%20professional%20automotive%20photography%20sharp%20detail%20neutral%20background&width=800&height=600&seq=camry_2020_v1&orientation=landscape',
  wrangler_2017: 'https://readdy.ai/api/search-image?query=2017%20Jeep%20Wrangler%20Unlimited%20Sport%20firecracker%20red%204%20door%20off%20road%20SUV%20parked%20on%20clean%20white%20studio%20background%20front%20three%20quarter%20view%20professional%20automotive%20photography%20sharp%20detail%20neutral%20background&width=800&height=600&seq=wrangler_2017_v1&orientation=landscape',
  accord_2021:   'https://readdy.ai/api/search-image?query=2021%20Honda%20Accord%20Sport%20sonic%20gray%20pearl%20sedan%20parked%20on%20clean%20white%20studio%20background%20front%20three%20quarter%20view%20professional%20automotive%20photography%20sharp%20detail%20neutral%20background&width=800&height=600&seq=accord_2021_v1&orientation=landscape',
  tacoma_2019:   'https://readdy.ai/api/search-image?query=2019%20Toyota%20Tacoma%20TRD%20Off-Road%20army%20green%20midsize%20pickup%20truck%20parked%20on%20clean%20white%20studio%20background%20front%20three%20quarter%20view%20professional%20automotive%20photography%20sharp%20detail%20neutral%20background&width=800&height=600&seq=tacoma_2019_v1&orientation=landscape',
  cx5_2018:      'https://readdy.ai/api/search-image?query=2018%20Mazda%20CX-5%20Grand%20Touring%20soul%20red%20crystal%20crossover%20SUV%20parked%20on%20clean%20white%20studio%20background%20front%20three%20quarter%20view%20professional%20automotive%20photography%20sharp%20detail%20neutral%20background&width=800&height=600&seq=cx5_2018_v1&orientation=landscape',
  corolla_2016:  'https://readdy.ai/api/search-image?query=2016%20Toyota%20Corolla%20LE%20classic%20silver%20compact%20sedan%20parked%20on%20clean%20white%20studio%20background%20front%20three%20quarter%20view%20professional%20automotive%20photography%20sharp%20detail%20neutral%20background&width=800&height=600&seq=corolla_2016_v1&orientation=landscape',
  explorer_2020: 'https://readdy.ai/api/search-image?query=2020%20Ford%20Explorer%20XLT%20carbonized%20gray%20three%20row%20SUV%20parked%20on%20clean%20white%20studio%20background%20front%20three%20quarter%20view%20professional%20automotive%20photography%20sharp%20detail%20neutral%20background&width=800&height=600&seq=explorer_2020_v1&orientation=landscape',
};

export const MOCK_VEHICLES: Vehicle[] = [
  {
    id: 1001,
    uuid: 'mock-001',
    name: '2021 Toyota RAV4 XLE',
    make: 'Toyota',
    model: 'RAV4',
    trim: 'XLE',
    stock_number: 'RHA-1001',
    year: 2021,
    price: 28995,
    mileage: 34200,
    bodyType: 'SUV',
    fuelType: 'Gasoline',
    transmission: 'Automatic',
    drivetrain: 'AWD',
    exteriorColor: 'Magnetic Gray',
    interiorColor: 'Black',
    engineSize: '2.5L 4-Cylinder',
    horsepower: '203',
    cylinders: '4',
    vin: '2T3P1RFV5MC123456',
    description: 'One-owner RAV4 XLE in excellent condition. Full service history, no accidents. Perfect for Oregon Coast weather with AWD and excellent ground clearance.',
    story: '',
    features: ['Apple CarPlay', 'Android Auto', 'Lane Departure Alert', 'Pre-Collision System', 'Blind Spot Monitor', 'Heated Front Seats', 'Power Liftgate', 'Dual-Zone Climate'],
    image: IMG.rav4_2021,
    images: [IMG.rav4_2021],
    status: 'available',
    mpgCity: 27,
    mpgHighway: 35,
    honesty_score: 94,
    has_carfax: true,
    service_records_bool: true,
    owner_count: 1,
    accident_free: true,
    dog_hair_status: 'clean',
    hot_deal: false,
    created_at: '2025-06-10T12:00:00.000Z',
  },
  {
    id: 1002,
    uuid: 'mock-002',
    name: '2019 Ford F-150 XLT',
    make: 'Ford',
    model: 'F-150',
    trim: 'XLT',
    stock_number: 'RHA-1002',
    year: 2019,
    price: 31500,
    mileage: 58400,
    bodyType: 'Truck',
    fuelType: 'Gasoline',
    transmission: 'Automatic',
    drivetrain: '4WD',
    exteriorColor: 'Oxford White',
    interiorColor: 'Medium Earth Gray',
    engineSize: '3.5L EcoBoost V6',
    horsepower: '375',
    cylinders: '6',
    vin: '1FTFW1E57KFA12345',
    description: 'Crew cab F-150 XLT with the powerful EcoBoost V6. Tow package, bed liner, and running boards. Ready for work or weekend adventures on the Oregon Coast.',
    story: '',
    features: ['Tow Package', 'Bed Liner', 'Running Boards', 'SYNC 3', 'Backup Camera', 'Trailer Brake Controller', 'FordPass Connect', 'Remote Start'],
    image: IMG.f150_2019,
    images: [IMG.f150_2019],
    status: 'available',
    mpgCity: 18,
    mpgHighway: 24,
    honesty_score: 88,
    has_carfax: true,
    service_records_bool: true,
    owner_count: 2,
    accident_free: true,
    dog_hair_status: 'clean',
    hot_deal: true,
    created_at: '2025-06-12T12:00:00.000Z',
  },
  {
    id: 1003,
    uuid: 'mock-003',
    name: '2020 Honda CR-V EX',
    make: 'Honda',
    model: 'CR-V',
    trim: 'EX',
    stock_number: 'RHA-1003',
    year: 2020,
    price: 24750,
    mileage: 41800,
    bodyType: 'SUV',
    fuelType: 'Gasoline',
    transmission: 'CVT',
    drivetrain: 'AWD',
    exteriorColor: 'Sonic Gray Pearl',
    interiorColor: 'Gray',
    engineSize: '1.5L Turbocharged 4-Cylinder',
    horsepower: '190',
    cylinders: '4',
    vin: '7FARW2H57LE123456',
    description: 'Clean one-owner CR-V EX with Honda Sensing suite. Excellent fuel economy and spacious interior. Perfect family SUV for coastal Oregon driving.',
    story: '',
    features: ['Honda Sensing', 'Sunroof', 'Apple CarPlay', 'Android Auto', 'Heated Front Seats', 'Power Tailgate', 'Wireless Charging', 'Lane Keep Assist'],
    image: IMG.crv_2020,
    images: [IMG.crv_2020],
    status: 'available',
    mpgCity: 28,
    mpgHighway: 34,
    honesty_score: 96,
    has_carfax: true,
    service_records_bool: true,
    owner_count: 1,
    accident_free: true,
    dog_hair_status: 'clean',
    hot_deal: false,
    created_at: '2025-06-07T12:00:00.000Z',
  },
  {
    id: 1004,
    uuid: 'mock-004',
    name: '2018 Subaru Outback 2.5i',
    make: 'Subaru',
    model: 'Outback',
    trim: '2.5i',
    stock_number: 'RHA-1004',
    year: 2018,
    price: 19900,
    mileage: 67300,
    bodyType: 'SUV',
    fuelType: 'Gasoline',
    transmission: 'CVT',
    drivetrain: 'AWD',
    exteriorColor: 'Wilderness Green',
    interiorColor: 'Warm Ivory',
    engineSize: '2.5L 4-Cylinder',
    horsepower: '175',
    cylinders: '4',
    vin: '4S4BSACC5J3123456',
    description: 'Classic Oregon car — Subaru Outback with symmetrical AWD, EyeSight driver assist, and plenty of cargo room. Well-maintained with full service records.',
    story: '',
    features: ['EyeSight Driver Assist', 'Symmetrical AWD', 'Roof Rails', 'Starlink Multimedia', 'Backup Camera', 'Blind Spot Detection', 'Rear Cross Traffic Alert'],
    image: IMG.outback_2018,
    images: [IMG.outback_2018],
    status: 'available',
    mpgCity: 25,
    mpgHighway: 33,
    honesty_score: 91,
    has_carfax: true,
    service_records_bool: true,
    owner_count: 1,
    accident_free: true,
    dog_hair_status: 'minor',
    hot_deal: false,
    created_at: '2025-06-01T12:00:00.000Z',
  },
  {
    id: 1005,
    uuid: 'mock-005',
    name: '2022 Chevrolet Silverado 1500 LT',
    make: 'Chevrolet',
    model: 'Silverado 1500',
    trim: 'LT',
    stock_number: 'RHA-1005',
    year: 2022,
    price: 38500,
    mileage: 22100,
    bodyType: 'Truck',
    fuelType: 'Gasoline',
    transmission: 'Automatic',
    drivetrain: '4WD',
    exteriorColor: 'Summit White',
    interiorColor: 'Jet Black',
    engineSize: '5.3L V8',
    horsepower: '355',
    cylinders: '8',
    vin: '3GCUYDED5NG123456',
    description: 'Low-mileage Silverado LT with the legendary 5.3L V8. Crew cab, Z71 off-road package, and tow package. Barely broken in — ready for serious work.',
    story: '',
    features: ['Z71 Off-Road Package', 'Tow Package', 'Chevy MyLink', 'Apple CarPlay', 'Android Auto', 'Heated Front Seats', 'Remote Start', 'Trailering App'],
    image: IMG.silverado_2022,
    images: [IMG.silverado_2022],
    status: 'available',
    mpgCity: 15,
    mpgHighway: 21,
    honesty_score: 97,
    has_carfax: true,
    service_records_bool: true,
    owner_count: 1,
    accident_free: true,
    dog_hair_status: 'clean',
    hot_deal: true,
    created_at: '2025-06-13T12:00:00.000Z',
  },
  {
    id: 1006,
    uuid: 'mock-006',
    name: '2020 Toyota Camry SE',
    make: 'Toyota',
    model: 'Camry',
    trim: 'SE',
    stock_number: 'RHA-1006',
    year: 2020,
    price: 21900,
    mileage: 49600,
    bodyType: 'Sedan',
    fuelType: 'Gasoline',
    transmission: 'Automatic',
    drivetrain: 'FWD',
    exteriorColor: 'Midnight Black',
    interiorColor: 'Black',
    engineSize: '2.5L 4-Cylinder',
    horsepower: '203',
    cylinders: '4',
    vin: '4T1B11HK5LU123456',
    description: 'Sharp-looking Camry SE in midnight black. Sport-tuned suspension, Toyota Safety Sense, and a clean Carfax. Great commuter car with excellent reliability.',
    story: '',
    features: ['Toyota Safety Sense', 'Sport-Tuned Suspension', 'Apple CarPlay', 'Android Auto', 'Dual-Zone Climate', 'Backup Camera', 'Lane Departure Alert', 'Adaptive Cruise'],
    image: IMG.camry_2020,
    images: [IMG.camry_2020],
    status: 'available',
    mpgCity: 29,
    mpgHighway: 39,
    honesty_score: 93,
    has_carfax: true,
    service_records_bool: true,
    owner_count: 1,
    accident_free: true,
    dog_hair_status: 'clean',
    hot_deal: false,
    created_at: '2025-06-05T12:00:00.000Z',
  },
  {
    id: 1007,
    uuid: 'mock-007',
    name: '2017 Jeep Wrangler Unlimited Sport',
    make: 'Jeep',
    model: 'Wrangler Unlimited',
    trim: 'Sport',
    stock_number: 'RHA-1007',
    year: 2017,
    price: 26800,
    mileage: 72400,
    bodyType: 'SUV',
    fuelType: 'Gasoline',
    transmission: 'Manual',
    drivetrain: '4WD',
    exteriorColor: 'Firecracker Red',
    interiorColor: 'Black',
    engineSize: '3.6L Pentastar V6',
    horsepower: '285',
    cylinders: '6',
    vin: '1C4BJWDG5HL123456',
    description: 'Classic Wrangler Unlimited in eye-catching red. 4-door, manual transmission, removable top and doors. Perfect for Oregon Coast beach access and forest roads.',
    story: '',
    features: ['Removable Top', 'Removable Doors', 'Rock-Trac 4WD', 'Tow Package', 'Skid Plates', 'Fog Lights', 'Uconnect 3', 'Backup Camera'],
    image: IMG.wrangler_2017,
    images: [IMG.wrangler_2017],
    status: 'available',
    mpgCity: 17,
    mpgHighway: 23,
    honesty_score: 85,
    has_carfax: true,
    service_records_bool: false,
    owner_count: 2,
    accident_free: true,
    dog_hair_status: 'clean',
    hot_deal: false,
    created_at: '2025-05-25T12:00:00.000Z',
  },
  {
    id: 1008,
    uuid: 'mock-008',
    name: '2021 Honda Accord Sport',
    make: 'Honda',
    model: 'Accord',
    trim: 'Sport',
    stock_number: 'RHA-1008',
    year: 2021,
    price: 25400,
    mileage: 31700,
    bodyType: 'Sedan',
    fuelType: 'Gasoline',
    transmission: 'CVT',
    drivetrain: 'FWD',
    exteriorColor: 'Sonic Gray Pearl',
    interiorColor: 'Black',
    engineSize: '1.5L Turbocharged 4-Cylinder',
    horsepower: '192',
    cylinders: '4',
    vin: '1HGCV1F34MA123456',
    description: 'Sporty Accord with low miles and a clean history. Honda Sensing standard, sport trim with 19-inch wheels and paddle shifters. Excellent daily driver.',
    story: '',
    features: ['Honda Sensing', 'Paddle Shifters', '19-Inch Wheels', 'Apple CarPlay', 'Android Auto', 'Heated Front Seats', 'Sunroof', 'Wireless Charging'],
    image: IMG.accord_2021,
    images: [IMG.accord_2021],
    status: 'available',
    mpgCity: 30,
    mpgHighway: 38,
    honesty_score: 95,
    has_carfax: true,
    service_records_bool: true,
    owner_count: 1,
    accident_free: true,
    dog_hair_status: 'clean',
    hot_deal: false,
    created_at: '2025-06-09T12:00:00.000Z',
  },
  {
    id: 1009,
    uuid: 'mock-009',
    name: '2019 Toyota Tacoma TRD Off-Road',
    make: 'Toyota',
    model: 'Tacoma',
    trim: 'TRD Off-Road',
    stock_number: 'RHA-1009',
    year: 2019,
    price: 34200,
    mileage: 44900,
    bodyType: 'Truck',
    fuelType: 'Gasoline',
    transmission: 'Automatic',
    drivetrain: '4WD',
    exteriorColor: 'Army Green',
    interiorColor: 'TRD Black/Cement',
    engineSize: '3.5L V6',
    horsepower: '278',
    cylinders: '6',
    vin: '3TMCZ5AN5KM123456',
    description: 'Iconic Tacoma TRD Off-Road in army green. Crawl Control, Multi-Terrain Select, locking rear diff. The ultimate Oregon Coast adventure truck.',
    story: '',
    features: ['Crawl Control', 'Multi-Terrain Select', 'Locking Rear Differential', 'TRD-Tuned Suspension', 'Apple CarPlay', 'JBL Audio', 'Heated Front Seats', 'Bed Liner'],
    image: IMG.tacoma_2019,
    images: [IMG.tacoma_2019],
    status: 'available',
    mpgCity: 18,
    mpgHighway: 22,
    honesty_score: 92,
    has_carfax: true,
    service_records_bool: true,
    owner_count: 1,
    accident_free: true,
    dog_hair_status: 'clean',
    hot_deal: true,
    created_at: '2025-06-14T12:00:00.000Z',
  },
  {
    id: 1010,
    uuid: 'mock-010',
    name: '2018 Mazda CX-5 Grand Touring',
    make: 'Mazda',
    model: 'CX-5',
    trim: 'Grand Touring',
    stock_number: 'RHA-1010',
    year: 2018,
    price: 22500,
    mileage: 53200,
    bodyType: 'SUV',
    fuelType: 'Gasoline',
    transmission: 'Automatic',
    drivetrain: 'AWD',
    exteriorColor: 'Soul Red Crystal',
    interiorColor: 'Parchment',
    engineSize: '2.5L 4-Cylinder',
    horsepower: '187',
    cylinders: '4',
    vin: 'JM3KFBDM5J0123456',
    description: 'Stunning Soul Red CX-5 Grand Touring — the top trim with leather, Bose audio, and heads-up display. Mazda\'s award-winning AWD crossover in excellent shape.',
    story: '',
    features: ['Bose Audio', 'Heads-Up Display', 'Leather Seats', 'Sunroof', 'Heated/Ventilated Seats', 'Blind Spot Monitoring', 'Rear Cross Traffic Alert', 'Apple CarPlay'],
    image: IMG.cx5_2018,
    images: [IMG.cx5_2018],
    status: 'available',
    mpgCity: 25,
    mpgHighway: 31,
    honesty_score: 90,
    has_carfax: true,
    service_records_bool: true,
    owner_count: 1,
    accident_free: true,
    dog_hair_status: 'clean',
    hot_deal: false,
    created_at: '2025-05-27T12:00:00.000Z',
  },
  {
    id: 1011,
    uuid: 'mock-011',
    name: '2016 Toyota Corolla LE',
    make: 'Toyota',
    model: 'Corolla',
    trim: 'LE',
    stock_number: 'RHA-1011',
    year: 2016,
    price: 13900,
    mileage: 81400,
    bodyType: 'Sedan',
    fuelType: 'Gasoline',
    transmission: 'CVT',
    drivetrain: 'FWD',
    exteriorColor: 'Classic Silver',
    interiorColor: 'Ash Gray',
    engineSize: '1.8L 4-Cylinder',
    horsepower: '132',
    cylinders: '4',
    vin: '2T1BURHE5GC123456',
    description: 'Reliable Corolla LE with a clean history. Toyota\'s legendary reliability at an affordable price. Great first car or commuter with excellent fuel economy.',
    story: '',
    features: ['Backup Camera', 'Bluetooth', 'Entune Audio', 'Automatic Climate Control', 'Keyless Entry', 'Toyota Safety Sense'],
    image: IMG.corolla_2016,
    images: [IMG.corolla_2016],
    status: 'available',
    mpgCity: 30,
    mpgHighway: 40,
    honesty_score: 87,
    has_carfax: true,
    service_records_bool: true,
    owner_count: 2,
    accident_free: true,
    dog_hair_status: 'clean',
    hot_deal: false,
    created_at: '2025-05-20T12:00:00.000Z',
  },
  {
    id: 1012,
    uuid: 'mock-012',
    name: '2020 Ford Explorer XLT',
    make: 'Ford',
    model: 'Explorer',
    trim: 'XLT',
    stock_number: 'RHA-1012',
    year: 2020,
    price: 32900,
    mileage: 38700,
    bodyType: 'SUV',
    fuelType: 'Gasoline',
    transmission: 'Automatic',
    drivetrain: '4WD',
    exteriorColor: 'Carbonized Gray',
    interiorColor: 'Ebony',
    engineSize: '2.3L EcoBoost 4-Cylinder',
    horsepower: '300',
    cylinders: '4',
    vin: '1FMSK8DH5LGA12345',
    description: 'Three-row Explorer XLT with 4WD and the powerful EcoBoost engine. Seats 7, tow package, and Ford Co-Pilot360. Great family hauler for Oregon adventures.',
    story: '',
    features: ['Ford Co-Pilot360', '3-Row Seating', 'Tow Package', 'Apple CarPlay', 'Android Auto', 'Heated Front Seats', 'Power Liftgate', 'Adaptive Cruise Control'],
    image: IMG.explorer_2020,
    images: [IMG.explorer_2020],
    status: 'available',
    mpgCity: 21,
    mpgHighway: 28,
    honesty_score: 89,
    has_carfax: true,
    service_records_bool: true,
    owner_count: 1,
    accident_free: true,
    dog_hair_status: 'minor',
    hot_deal: false,
    created_at: '2025-06-03T12:00:00.000Z',
  },
];
